import { useQuery } from '@tanstack/react-query';

interface CanCreateResponse {
  canCreate: boolean;
}

/**
 * Hook to check if the current user can create content (pulses/sequences) in a project
 * Uses the /api/projects/:projectId/can-create endpoint
 */
export function useCanCreateInProject(projectId: string | undefined) {
  return useQuery<CanCreateResponse>({
    queryKey: ['/api/projects', projectId, 'can-create'],
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  });
}
